import { API_BASE_URL } from "./api";
import { Post } from "../types/Post";

export const getTimeline = async (): Promise<Post[]> => {
  const response = await fetch(`${API_BASE_URL}/timeline`);
  if (!response.ok) {
    throw new Error("タイムラインの取得に失敗しました。");
  }
  return await response.json();
};
